import React, { FC } from 'react'
import TopBar, { IIcon } from '@components/std-components/TopBar'
import * as css from './SATopbar.css'
import { CentricTypography as Typography } from '@core/component/CentricTypography'
import { TopbarBSGandClientName } from './components/TopbarBSGandClientName'
import classNames from 'classnames'

export interface ISATopBarProps {
  title?: string
  mainRightIcons?: IIcon[]
  subRightIcons?: any
  subLeftIcons?: IIcon[]
  enhancedViewEnabled?: boolean
}

const SATopBar: FC<ISATopBarProps> = ({
  title,
  subRightIcons,
  subLeftIcons,
  mainRightIcons,
  enhancedViewEnabled
}) => {
  const leftIcons = [
    {
      name: 'bsgAndClient',
      isCustomElement: true,
      customElement: () => <TopbarBSGandClientName />,
      showIcon: true
    }
  ]
  const rowleftIcons = subLeftIcons
    ? subLeftIcons
    : title
    ? [
        {
          name: 'pageTitle',
          isCustomElement: true,
          customElement: () => (
            <div className={css.pageTitle}>
              <Typography variant={'h3'} noWrap>
                {title}
              </Typography>
            </div>
          ),
          showIcon: true
        }
      ]
    : []

  return (
    <div
      className={classNames('flex column', css['sa-top-bar-container'], {
        'enhanced-topbar': enhancedViewEnabled
      })}
      id='SATopbar'
    >
      <TopBar
        leftIcons={leftIcons}
        rightIcons={mainRightIcons}
        showRightIcons={mainRightIcons?.length > 0}
        showLeftIcons={true}
        leftIconsContainerCSS={css['left-icon-wrapper']}
      />
      <TopBar
        leftIcons={rowleftIcons}
        rightIcons={subRightIcons}
        showRightIcons={true}
        showLeftIcons={true}
        leftIconsContainerCSS={css['left-icon-wrapper']}
        rightIconsContainerCSS={css['right-icon-wrapper']}
      />
    </div>
  )
}

export default SATopBar
